import { ITCFConsent, TCFVendorTypes } from "../TCFConsentProvider/types";

const isTCFVendorAccepted = (
  id: number,
  consent: ITCFConsent,
  type: TCFVendorTypes,
): boolean => {

  const stateName: { [key: string]: keyof ITCFConsent } = {
    [TCFVendorTypes.VENDORS]: 'vendors',
    [TCFVendorTypes.LEG_INT]: 'vendorsLegitimateInterest',
    [TCFVendorTypes.GATP]: 'gatp',
  }

  return !!consent[stateName[type]][id];
};

export default isTCFVendorAccepted;
